(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-alpi-reference"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mk-alpi-carousel')) {
    customElements.define('mk-alpi-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const track = this.querySelector('[data-track]');
        const slides = Array.from(this.querySelectorAll('[data-slide]'));
        const dots = Array.from(this.querySelectorAll('[data-dot]'));
        const previous = this.querySelector('[data-previous]');
        const next = this.querySelector('[data-next]');
        const status = this.querySelector('[data-status]');
        if (!track || !slides.length) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const index = () => Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
        const go = (target) => {
          const clamped = Math.min(slides.length - 1, Math.max(0, target));
          track.scrollTo({ left: track.clientWidth * clamped, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        };
        const update = () => {
          const current = index();
          dots.forEach((dot, i) => {
            if (i === current) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          previous.disabled = current === 0;
          next.disabled = current === slides.length - 1;
          status.textContent = status.dataset.format.replace('__number__', current + 1);
        };
        previous.addEventListener('click', () => go(index() - 1), { signal });
        next.addEventListener('click', () => go(index() + 1), { signal });
        dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), { signal }));
        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            go(index() + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        let frame;
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(update);
        }, { signal, passive: true });
        signal.addEventListener('abort', () => cancelAnimationFrame(frame), { once: true });
        this.querySelector('[data-controls]').hidden = false;
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-collections-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector("[data-mk-editorial]");
    if (!root) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const panels = Array.from(root.querySelectorAll("[data-mk-panel]"));
    if (panels.length < 2) return;

    const isRootScroller = (el) =>
      el === document.documentElement ||
      el === document.body ||
      el === document.scrollingElement;

    // Horizon scrolle .page-wrapper au-delà de 990px, le document en dessous.
    const findScroller = () => {
      let el = root.parentElement;
      while (el && el !== document.body) {
        const style = window.getComputedStyle(el);
        if (
          /(auto|scroll)/.test(style.overflowY) &&
          el.scrollHeight - el.clientHeight > 4
        ) {
          return el;
        }
        el = el.parentElement;
      }
      return document.scrollingElement || document.documentElement;
    };

    const scrollTopOf = (scroller) =>
      isRootScroller(scroller) ? window.scrollY : scroller.scrollTop;

    const focusClearance = () => {
      const raw = getComputedStyle(root)
        .getPropertyValue("--mk-focus-clearance")
        .trim();
      const px = raw.endsWith("rem")
        ? parseFloat(raw) *
          parseFloat(getComputedStyle(document.documentElement).fontSize)
        : parseFloat(raw);
      return Number.isFinite(px) ? Math.round(px) : 92;
    };

    // Le footer est la dernière étape du scroll, au même titre qu'une planche.
    const footer = document.querySelector("footer");
    const stops = footer ? panels.concat([footer]) : panels;
    const isFooter = (el) => el === footer;

    const maxScrollOf = (scroller) =>
      isRootScroller(scroller)
        ? (document.scrollingElement || document.documentElement).scrollHeight -
          window.innerHeight
        : scroller.scrollHeight - scroller.clientHeight;

    const targetFor = (scroller, el) => {
      const top = el.getBoundingClientRect().top;
      const clearance = focusClearance();
      let target;
      if (isRootScroller(scroller)) {
        target = Math.round(top + window.scrollY - clearance);
      } else {
        target = Math.round(
          top -
            scroller.getBoundingClientRect().top +
            scroller.scrollTop -
            clearance,
        );
      }
      // Pas de scroll négatif (1re planche déjà sous le header in-flow),
      // ni au-delà du bas du document (footer plus court que l'écran).
      return Math.min(Math.max(0, target), maxScrollOf(scroller));
    };

    const nearestIndex = (scroller) => {
      const current = scrollTopOf(scroller);
      let best = 0;
      let bestDist = Infinity;
      stops.forEach((stop, i) => {
        const dist = Math.abs(targetFor(scroller, stop) - current);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    };

    let animating = false;

    const goTo = (scroller, index) => {
      const i = Math.max(0, Math.min(stops.length - 1, index));
      const stop = stops[i];
      animating = true;

      // Le snap CSS lutterait contre l'animation JS.
      scroller.style.scrollSnapType = "none";
      scroller.scrollTo({ top: targetFor(scroller, stop), behavior: "smooth" });

      let timer = 0;
      const finish = () => {
        if (!animating) return;
        animating = false;
        scroller.removeEventListener("scroll", onScroll);
        // "instant" ignore le scroll-behavior: smooth du thème : atterrissage exact.
        scroller.scrollTo({ top: targetFor(scroller, stop), behavior: "instant" });
        // Sur le footer on garde le snap coupé : il le remonterait sur la 3e
        // planche. Ailleurs on rend la main au CSS.
        scroller.style.scrollSnapType = isFooter(stop) ? "none" : "";
      };
      const onScroll = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(finish, 110);
      };

      scroller.addEventListener("scroll", onScroll, { passive: true });
      timer = window.setTimeout(finish, 900);
    };

    const step = (scroller, direction) => {
      const current = scrollTopOf(scroller);
      const firstTop = targetFor(scroller, stops[0]);
      const lastTop = targetFor(scroller, stops[stops.length - 1]);

      // Au-dessus de la première étape ou sous la dernière : on y revient d'abord.
      if (direction > 0 && current < firstTop - 4) return 0;
      if (direction < 0 && current > lastTop + 4) return stops.length - 1;

      const next = nearestIndex(scroller) + direction;
      return next < 0 || next > stops.length - 1 ? null : next;
    };

    window.addEventListener(
      "wheel",
      (event) => {
        if (event.ctrlKey) return;
        const scroller = findScroller();
        if (animating) {
          event.preventDefault();
          return;
        }
        if (Math.abs(event.deltaY) < 4) return;

        const next = step(scroller, event.deltaY > 0 ? 1 : -1);
        if (next === null) return;

        event.preventDefault();
        goTo(scroller, next);
      },
      { passive: false },
    );

    window.addEventListener("keydown", (event) => {
      const keysDown = ["ArrowDown", "PageDown", " "];
      const keysUp = ["ArrowUp", "PageUp"];
      let direction = 0;
      if (keysDown.includes(event.key)) direction = 1;
      if (keysUp.includes(event.key)) direction = -1;
      if (!direction) return;

      // activeElement est toujours un Element : event.target peut être window
      // ou document, qui n'ont pas closest().
      const active = document.activeElement;
      if (active && active.closest("input, textarea, select, [contenteditable]")) return;

      const scroller = findScroller();
      if (animating) {
        event.preventDefault();
        return;
      }

      const next = step(scroller, direction);
      if (next === null) return;

      event.preventDefault();
      goTo(scroller, next);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-home-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll("[data-mk-bs]");
    roots.forEach((root) => {
      const track = root.querySelector("[data-mk-bs-track]");
      const prev = root.querySelector("[data-mk-bs-prev]");
      const next = root.querySelector("[data-mk-bs-next]");
      if (!track || !next) return;

      const card = () => track.querySelector(".mk-bs__item");
      const step = () => {
        const item = card();
        if (!item) return track.clientWidth * 0.8;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 12;
        return item.getBoundingClientRect().width + gap;
      };

      const sync = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth - 4);
        const x = Math.max(0, track.scrollLeft);
        if (root) root.classList.toggle("is-scrolled", x > 24);
        next.classList.toggle("is-disabled", x >= max);
      };

      try { track.scrollTo({ left: 0 }); } catch (e) { track.scrollLeft = 0; }

      prev?.addEventListener("click", () => {
        track.scrollBy({ left: -step(), behavior: "smooth" });
      });
      next.addEventListener("click", () => {
        track.scrollBy({ left: step(), behavior: "smooth" });
      });
      track.addEventListener("scroll", sync, { passive: true });
      window.addEventListener("resize", sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-home-table"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMq = window.matchMedia("(prefers-reduced-motion: reduce)");

    const bind = (section) => {
      const video = section.querySelector("[data-mk-tb-video]");
      if (!video) return;

      const stop = () => {
        video.pause();
      };

      const play = async () => {
        if (reducedMq.matches) {
          stop();
          return;
        }
        video.muted = true;
        try {
          await video.play();
        } catch (_) {
          /* autoplay blocked — first frame still visible */
        }
      };

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
              play();
            } else {
              stop();
            }
          });
        },
        { threshold: [0, 0.2, 0.55] },
      );

      io.observe(section);

      reducedMq.addEventListener("change", () => {
        if (reducedMq.matches) stop();
        else play();
      });
    };

    document.querySelectorAll("[data-mk-tb]").forEach(bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-home-temps-calme"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopMq = window.matchMedia("(min-width: 750px)");
    const reducedMq = window.matchMedia("(prefers-reduced-motion: reduce)");

    const signalReady = () => {
      if (window.__mkHeroReady) return;
      window.__mkHeroReady = true;
      window.dispatchEvent(new Event("mk-hero-ready"));
    };

    const stopVideos = (section, videos) => {
      videos.forEach((video) => {
        video.pause();
        video.removeAttribute("src");
        video.classList.remove("is-visible");
        delete video.dataset.loadedSrc;
      });
      section.classList.add("mk-tc--static");
      signalReady();
    };

    const waitCanPlay = (video) =>
      new Promise((resolve, reject) => {
        if (video.readyState >= 3) {
          resolve();
          return;
        }
        const fail = setTimeout(() => reject(new Error("video-timeout")), 10000);
        const done = () => {
          clearTimeout(fail);
          resolve();
        };
        video.addEventListener("canplaythrough", done, { once: true });
        video.addEventListener(
          "error",
          () => {
            clearTimeout(fail);
            reject(new Error("video-error"));
          },
          { once: true },
        );
      });

    const waitPlaying = (video) =>
      new Promise((resolve, reject) => {
        if (!video.paused && video.readyState >= 2) {
          resolve();
          return;
        }
        const fail = setTimeout(() => reject(new Error("play-timeout")), 8000);
        video.addEventListener(
          "playing",
          () => {
            clearTimeout(fail);
            resolve();
          },
          { once: true },
        );
      });

    const parseSources = (raw) => {
      try {
        const sources = JSON.parse(raw || "[]");
        if (!Array.isArray(sources) || sources.length === 0 || sources.some((src) => !src)) {
          return null;
        }
        return sources;
      } catch {
        return null;
      }
    };

    const initSection = (section) => {
      const stack = section.querySelector("[data-mk-tc-videos]");
      const videos = stack ? Array.from(stack.querySelectorAll("[data-mk-tc-video]")) : [];
      if (videos.length < 2) {
        signalReady();
        return;
      }

      section._mkTcCleanup?.();
      section._mkTcCleanup = null;

      if (reducedMq.matches) {
        stopVideos(section, videos);
        return;
      }

      const sources = parseSources(
        desktopMq.matches
          ? section.dataset.mkTcSourcesDesk
          : section.dataset.mkTcSourcesMob,
      );

      if (!sources) {
        stopVideos(section, videos);
        return;
      }

      section.classList.remove("mk-tc--static");

      let active = videos[0];
      let buffer = videos[1];
      let index = 0;
      let swapping = false;
      const ac = new AbortController();
      const signal = ac.signal;

      section._mkTcCleanup = () => ac.abort();

      const show = (video) => {
        videos.forEach((el) => el.classList.toggle("is-visible", el === video));
      };

      const prime = async (video, src) => {
        if (video.dataset.loadedSrc === src && video.readyState >= 3) return;
        video.dataset.loadedSrc = src;
        video.src = src;
        video.muted = true;
        video.setAttribute("playsinline", "");
        video.setAttribute("webkit-playsinline", "");
        video.load();
        await waitCanPlay(video);
      };

      const prepareNext = () => {
        if (sources.length < 2) return;
        const upcoming = (index + 1) % sources.length;
        prime(buffer, sources[upcoming]).catch(() => {});
      };

      const swap = async () => {
        if (swapping || sources.length < 2) return;
        swapping = true;

        const nextIndex = (index + 1) % sources.length;
        const previous = active;

        try {
          await prime(buffer, sources[nextIndex]);
          buffer.currentTime = 0;
          buffer.muted = true;
          await buffer.play();
          await waitPlaying(buffer);

          previous.pause();
          previous.removeAttribute("src");
          delete previous.dataset.loadedSrc;

          show(buffer);
          active = buffer;
          buffer = previous;
          index = nextIndex;
          prepareNext();
        } catch {
          stopVideos(section, videos);
        } finally {
          swapping = false;
        }
      };

      const onTimeupdate = () => {
        if (swapping || sources.length < 2) return;
        const remaining = active.duration - active.currentTime;
        if (!Number.isFinite(remaining) || remaining > 0.5) return;
        prepareNext();
      };

      const start = async () => {
        try {
          await prime(active, sources[index]);
          active.currentTime = 0;
          active.muted = true;
          show(active);
          await active.play();
          await waitPlaying(active);
          signalReady();
          prepareNext();
        } catch {
          stopVideos(section, videos);
        }
      };

      const bindVideo = (video) => {
        video.addEventListener(
          "timeupdate",
          () => {
            if (video !== active) return;
            onTimeupdate();
          },
          { signal },
        );
        video.addEventListener(
          "ended",
          () => {
            if (video !== active) return;
            swap();
          },
          { signal },
        );
      };

      videos.forEach(bindVideo);

      start();
    };

    document.querySelectorAll("[data-mk-tc]").forEach(initSection);

    desktopMq.addEventListener("change", () => {
      document.querySelectorAll("[data-mk-tc]").forEach(initSection);
    });
    reducedMq.addEventListener("change", () => {
      document.querySelectorAll("[data-mk-tc]").forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-promo-banner"]) return;
  try {
    
  (() => {
    const setPromoMessage = (root, showWelcome) => {
      const offer = root.querySelector('[data-mk-promo-offer]');
      const welcome = root.querySelector('[data-mk-welcome-open]');
      [offer, welcome].forEach((slide) => {
        if (!slide) return;
        const active = slide === (showWelcome ? welcome : offer);
        slide.dataset.active = String(active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
    };
    function initPromoRotation() {
      document.querySelectorAll('[data-mk-promo]').forEach((root) => {
        if (root.dataset.rotationInitialized) return;
        root.dataset.rotationInitialized = 'true';
        const welcome = root.querySelector('[data-mk-welcome-open]');
        if (!welcome) return;
        const rotation = window.setInterval(() => {
          if (!root.isConnected) { window.clearInterval(rotation); return; }
          if (welcome.hidden) { setPromoMessage(root, false); return; }
          if (document.visibilityState !== 'visible' || root.matches(':hover, :focus-within') || document.querySelector('[data-mk-welcome-dialog][open]')) return;
          setPromoMessage(root, welcome.dataset.active !== 'true');
        }, 6000);
      });
    }
    const subscribedKey = 'mk-newsletter-subscribed-v1';
    const dismissedKey = 'mk-welcome-dismissed-until-v1';
    const shownKey = 'mk-welcome-shown-v1';
    const read = (kind, key) => {
      try { return window[kind].getItem(key); } catch { return null; }
    };
    const write = (kind, key, value) => {
      try { window[kind].setItem(key, value); return true; } catch { return false; }
    };
    const isSubscribed = () => read('localStorage', subscribedKey) === '1';
    const hideOpeners = () => document.querySelectorAll('[data-mk-welcome-open]').forEach((opener) => {
      opener.hidden = true;
      const promo = opener.closest('[data-mk-promo]');
      if (promo) setPromoMessage(promo, false);
    });
    const rememberSubscription = () => {
      write('localStorage', subscribedKey, '1');
      write('sessionStorage', subscribedKey, '1');
      hideOpeners();
    };
    function initWelcome() {
      if (document.querySelector('[data-mk-welcome-subscribed]')) rememberSubscription();
      if (isSubscribed() || read('sessionStorage', subscribedKey) === '1') hideOpeners();
      document.querySelectorAll('[data-mk-welcome-dialog]').forEach((dialog) => {
        if (dialog.dataset.initialized) return;
        dialog.dataset.initialized = 'true';
        const opener = document.querySelector('[data-mk-welcome-open][aria-controls="' + dialog.id + '"]');
        let restoreTarget = null;
        let timer = null;
        let attempts = 0;
        const hasSubscription = () => isSubscribed() || read('sessionStorage', subscribedKey) === '1';
        const show = (target = null) => {
          if (dialog.open || !dialog.isConnected) return;
          restoreTarget = target;
          dialog.showModal();
          document.documentElement.classList.add('mk-welcome-open');
        };
        const clearTimer = () => { window.clearTimeout(timer); timer = null; };
        const snooze = () => {
          const days = Math.min(30, Math.max(1, Number(dialog.dataset.snoozeDays) || 7));
          write('localStorage', dismissedKey, String(Date.now() + days * 86400000));
          write('sessionStorage', shownKey, '1');
        };
        opener?.addEventListener('click', () => {
          clearTimer();
          if (!hasSubscription()) show(opener);
        });
        dialog.querySelectorAll('[data-mk-welcome-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('mk-welcome-open');
          clearTimer();
          if (!hasSubscription()) snooze();
          if (restoreTarget?.isConnected && !restoreTarget.hidden) restoreTarget.focus({ preventScroll: true });
        });
        window.addEventListener('storage', (event) => {
          if (event.key === subscribedKey && event.newValue === '1') {
            hideOpeners();
            clearTimer();
            if (dialog.open) dialog.close();
          }
        });
        if (dialog.querySelector('[data-mk-welcome-success]')) rememberSubscription();
        if (dialog.querySelector('[data-mk-welcome-feedback]')) { show(); return; }
        if (hasSubscription() || dialog.dataset.autoOpen !== 'true') return;
        const autoOpen = () => {
          if (hasSubscription() || !dialog.isConnected || dialog.open) return;
          if (read('sessionStorage', shownKey) === '1' || Number(read('localStorage', dismissedKey)) > Date.now()) return;
          const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
          const anotherModal = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some((element) => element !== dialog && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
          if (document.visibilityState !== 'visible' || anotherModal || editing) {
            if (++attempts < 60) timer = window.setTimeout(autoOpen, 1000);
            return;
          }
          if (!write('sessionStorage', shownKey, '1')) return;
          show();
        };
        timer = window.setTimeout(autoOpen, Math.max(3, Number(dialog.dataset.delay) || 8) * 1000);
      });
    }
    initPromoRotation();
    initWelcome();
    document.addEventListener('shopify:section:load', initPromoRotation);
    document.addEventListener('shopify:section:load', initWelcome);
  })();

  } catch(e) { console.error(e); }
})();
})();
